var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"spinning":!this.chartData}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Exchange rate of population aging countries")]),_c('svg',{attrs:{"align":"center","id":"exchange-rate-chart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }